export default __webpack_public_path__ + "static/media/bearshamanbg.be281bfa.jpg";